// LocationSelector.js

import React, { useCallback } from 'react';
import { Button, FormGroup } from 'reactstrap';
import { isEmpty } from 'lodash-es';
import { SmallOutlineButton, FlexStartRow, FormLabel } from '../common/forms/FormElements';
import { CountyLabel } from '../uscounties/CountyLabel';
import { util } from '../Util';
import { Address } from '../address/Address';

const LocationSelector = ({
  label,
  type,
  stateData,
  contract,
  usCounties,
  addressFormRef, 
  setSelectedAddressType,
  locationRequired,
  isDisabled,
}) => {
    const location = stateData?.[type];

    // If no location, we open the address form in "create" mode.
    const onAddLocation = useCallback(() => {
        if (!contract) return;
        setSelectedAddressType(type);

        const newLocation = new Address(contract.countryId, contract.countryCode);
        
        const title = `New ${type === 'meetingLocation' ? 'Meeting' : 'Job'} Location`;
            addressFormRef.current.open(
            newLocation,
            title,
            true,
            `Same as ${type === 'meetingLocation' ? 'Job Location' : 'Meeting Location'}`
        );
    }, [contract, type, addressFormRef, setSelectedAddressType]);

    // If there's an existing location, we open it in "edit" mode.
    const onEditLocation = useCallback(() => {
        if (!location) return;
        setSelectedAddressType(type);

        const title = `Edit ${type === 'meetingLocation' ? 'Meeting' : 'Job'} Location`;
        addressFormRef.current.open(location, title);
    }, [location, addressFormRef, setSelectedAddressType, type]);

    return (
        <FormGroup>
            <FormLabel htmlFor={type} text={label} required />
            {location && location.address1 ? (
                <FlexStartRow>
                    <SmallOutlineButton
                        onClick={onEditLocation}
                        text="Edit"
                        disabled={isDisabled}
                    />
                    <span className="form-control-plaintext ml-2">
                        {location.address1}, {location.city}, {location.state} {location.zip}{' '}
                        (<CountyLabel {...util.getCounty(usCounties, location) || {}} />)
                    </span>
                </FlexStartRow>
            ) : (
                <Button
                type="button"
                color="secondary"
                size="sm"
                style={locationRequired}
                onClick={onAddLocation}
                disabled={isDisabled}
                >
                    Add {label}
                </Button>
            )}
            {!isEmpty(locationRequired) && (
                <small className="text-danger">
                    Job location is required.
                </small>
            )}
        </FormGroup>
    );
};

export default LocationSelector;
